import { call, put, takeLatest } from 'redux-saga/effects'
import { AdminFetchWallets } from 'src/constants/actionTypes'
import { Endpoints } from 'src/constants/endpoints'
import type { FetchWalletsPayload, PartnerWallet } from 'src/interfaces/wallet'
import { resolveErrorMessage } from 'src/utils/sagaErrorMessage'
import { captureSentryError } from 'src/utils/sentry'
import type { AsyncAction } from 'src/utils/reduxUtils'
import { callSecureApi } from './api/callApi'

export function* onFetchWallets(action: AsyncAction<FetchWalletsPayload>) {
  try {
    // `activeOnly` accepts only 'true'/'false' (strict transform); false is the default, so omit
    // it. The default INCLUDES wallets of deleted partners.
    const { payload }: { payload: { data: PartnerWallet[] } } = yield call(
      callSecureApi,
      Endpoints.AdminFetchWallets,
      { method: 'GET', query: { activeOnly: action.payload?.activeOnly ? 'true' : undefined } },
    )

    const wallets = payload?.data ?? []

    yield put(AdminFetchWallets.success(wallets))

    if (action.next) {
      action.next(null, wallets)
    }
  } catch (error: unknown) {
    captureSentryError(error, { message: '[saga.wallet.onFetchWallets] error' })

    yield put(AdminFetchWallets.failed(error))

    if (action.next) {
      action.next(resolveErrorMessage(error, 'Failed to load wallets'))
    }
  }
}

export function* walletSaga() {
  yield takeLatest(AdminFetchWallets.type.REQUEST, onFetchWallets)
}
